import DefaultParagraph from "~/components/common/defaultParagraph";
import { useLanguage } from "~/contexts/providers/language";
import englishTranslations from "~/localization/en";
import frenchTranslations from "~/localization/fr";

const CultureIntroduction = () => {
  const { language } = useLanguage();

  const aboutText =
    language === "En"
      ? englishTranslations.culturePage.intro
      : frenchTranslations.culturePage.intro;

  return (
    <DefaultParagraph
      title=""
      description={aboutText}
      style={{ paddingTop: "7rem" }}
    />
  );
};

export default CultureIntroduction;
